module.exports = __webpack_public_path__ + "static/media/logo.6bb4a4e0.png";